<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2"><span class="tabulation1">Foreword by Dennis Edwards</span></a></div>
<div class="SOM_pre"><a href="#/pre3"><span class="tabulation1">Introduction</span></a></div>
<div class="SOM_part"><a href="#/p1">PART 1: AN ECCLESIOLOGY FOR JUSTICE</a></div>
<div class="SOM_chap"><a href="#/p1chap1">1 Justice Isn’t an Outreach Strategy<br/><i><span class="tabulation1">A Way of Life for the People of God</span></i></a></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample">2 Exiles in the Promised Land<br/><i><span class="tabulation1">The Church as Prophetic Alternative</span></i></span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample">3 Demonstrating Mañana<br/><i><span class="tabulation1">The Church as a Parable of God’s Intent</span></i></span></div>
<div class="SOM_chap"><span href="#/p1chap4" title="Link target outside of Sample">4 Gardeners of Shalom<br/><i><span class="tabulation1">The Church for Flourishing and Transformation</span></i></span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">PART 2: JUSTICE IN OUR CONGREGATIONAL LIFE</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample">5 Low-Ground Church<br/><i><span class="tabulation1">Discerning Vision in a High-Ground World</span></i></span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample">6 Recovering Kinship<br/><i><span class="tabulation1">Hospitality as Resistance</span></i></span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample">7 Finding Common Kingdom Ground<br/><i><span class="tabulation1">Discipling People into Shalom Community</span></i></span></div>
<div class="SOM_chap"><span href="#/p2chap4" title="Link target outside of Sample">8 Worship<br/><i><span class="tabulation1">Questions That Drive How We Gather</span></i></span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">PART 3: WHAT’S NEXT?</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample">9 Power<br/><i><span class="tabulation1">A Conversation About the Linchpin of Justice with Juliet Liu and Brandon Green</span></i></span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample"><span class="tabulation1">Epilogue<br/><i><span class="tabulation1">Commence Justice</span></i></span></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample"><span class="tabulation1">Acknowledgments</span></span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample"><span class="tabulation1">Notes</span></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample"><span class="tabulation1">Praise for <i>Becoming a Just Church</i></span></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample"><span class="tabulation1">More Titles from InterVarsity Press</span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?22390e2b